import axios from 'axios'
import config from './config'
import qs from 'qs'
import { Message } from 'element-ui'
import ttp from './hideloading'

import { showLoading, hideLoading } from '../assets/js/loading.js';
import { json } from 'd3-fetch'
import { cosh } from 'core-js/core/number'

const instance = axios.create({
	headers: {
		'Content-Type': 'application/json;charset=UTF-8',
	},
	timeout: 300000,
})

// let aaa = 'aaa:0729416781964282228,xxx1729416781964282228xxxddd5555584487545454dxxx'
// console.log('---------------------------')
// console.log(aaa)
// console.log(aaa.match((/[:][0-9]*\d{15}[,]/g)))
// console.log('---------------------------')
// instance.defaults.transformResponse = [
// 	data => {
// 		let taskIdAll = []
// 		taskIdAll = data.match((/[:][0-9]*\d{15}[,]/g)) ? data.match((/[:][0-9]*\d{15}[,]/g)) : [] // 正则获取19位数字的值
// 		taskIdAll = [...new Set(taskIdAll)]
// 		if (taskIdAll.length > 0) {
// 			for (let i = 0; i < taskIdAll.length; i++) {
// 				data = data.replaceAll(taskIdAll[i], `:"${taskIdAll[i].substring(1, taskIdAll[i].length - 1)}",`)
// 			}
// 		}
// 		// console.log(typeof data)
// 		// typeof value === "string"
// 		return JSON.parse(data)
// 		// return  typeof value === "string"?JSON.parse(data): data
// 	}
// ]
// instance.defaults.transformResponse = [
// 	data=>{
// 		console.log(data)
// 		console.log(data.match(/[0-9]\d{7}/g))
// 		const taskId = data.match((/[0-9]\d{7}/g)[0] // 正则获取19位数字的值
// 		console.log(taskId)
// 		data = data.replace(taskId,`"${taskId}"`) // 补上双引号
// 		// // return jsonlint.parse(data)
// 		console.log(JSON.parse(data))
// 		return JSON.parse(data)
// 	}
// ]
let needSetUrl = ['/temu/auth/getTemuAuthInfo', '/pattern/patternBadPage', '/shopOrder/updateCustomizedTxt', '/pattern/deletePattern', '/shopOrder/selectAllTemuShop',
'/shopOrder/getAttrs','/shopOrder/getParentSpec','/shopOrder/createSpec','/shopOrder/getSizecharts','/shopOrder/getSizechartsClass','/shopOrder/getSizechartsSettings',
'/shopOrder/getSizeChartsMeta','/shopOrder/batchAddGoods','/item/updatePriceByCusCode','/access/updateUserDistributorLevel','/pattern/standardPatternPage','/pattern/publishPlatformHeat'
,'/shopOrder/uploadPintImage','/pattern/orderBindPrintImage','/pattern/deleteStandardPattern','/item/updateDefaultActivityPrice','/item/getMarketingActivityList','/shopOrder/updateOrderItemImage']
instance.interceptors.request.use((req) => {

	let needStatus = needSetUrl.filter(element => req.url.indexOf(element) != -1).length > 0 ? true : false
	if (JSON.parse(localStorage.getItem('userInfo'))) {
		if (req.url == 'https://adminbylgb.dianxiaosheng.com/service/integration/withdraw') {
			req.headers.token = 'ItsXgkuRhZl2z26rMMTY5QTLKGEMdM'
		} else if (req.url == 'http://47.57.9.89:8085/access/getPublicPurchaseUser'
			|| req.url == 'https://erp.shopsbu.com/service/access/getPublicPurchaseUser') {
			req.headers.token = 'ItsXgkuRhZl2z26rMMTY5QTLKGEMdM'
		}
		else {
			req.headers.token = JSON.parse(localStorage.getItem('userInfo')).token
		}

	}

	if (req.url.indexOf('/shopOrder/createDxsOrderExcel') > -1) {
		req.headers['Content-Type'] = 'multipart/form-data; boundary=<calculated when request is sent>'


	}
	// if (req.url.indexOf('/temu/auth/getTemuAuthInfo') > -1 || req.url.indexOf('/pattern/patternBadPage') > -1 || req.url.indexOf('/shopOrder/updateCustomizedTxt') > -1 || req.url.indexOf('/pattern/deletePattern') > -1) {
	// 	req.headers['Content-Type'] = 'multipart/form-data'
	// }
	if (needStatus) {
		req.headers['Content-Type'] = 'multipart/form-data'
	}
	// if (req.url.indexOf('/access/upload') == -1 && req.url.indexOf('/integral/deduct') == -1 && req.url.indexOf('/shopOrder/createDxsOrderExcel') == -1 && req.url.indexOf('/temu/auth/getTemuAuthInfo') == -1 && req.url.indexOf('/pattern/patternBadPage') == -1 && req.url.indexOf('/shopOrder/updateCustomizedTxt') == -1 && req.url.indexOf('/pattern/deletePattern') == -1) {
	if (req.url.indexOf('/access/upload') == -1 && req.url.indexOf('/integral/deduct') == -1 && req.url.indexOf('/shopOrder/createDxsOrderExcel') == -1 && !needStatus) {
		if (req.data) {
			let obj = JSON.parse(JSON.stringify(req.data))
			obj.partnerId = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).partnerId : obj.partnerId ? obj.partnerId : null
			if (obj.token) {
				req.headers.token = obj.token
			}

			if (req.url.indexOf('wechat-pay/create-order') > -1) {
				req.url = 'https://erp.shopsbu.com/service/wechat-pay/create-order'
			}
			if (req.url.indexOf('auditOrderAll') != -1 || req.url.indexOf('auditUnPassOrderAll') != -1) {

				// req.data=JSON.stringify(obj)
			} else {
				req.data = JSON.stringify(obj)
			}

			// if (req.url.indexOf('queryPendingOrders') != -1) {
			// 	console.log(req)
			// 	console.log(req.data)
			// 	console.log(JSON.parse(JSON.stringify(req.data)))
			// 	console.log('++5+++')
			// }
		}
	} else if (req.headers['biaoshi'] == '111') {
		console.log('=====2=====')
	}
	return req;
}, (err) => {
	hideLoading()
	return Promise.reject(err) //请求错误时，直接结束
});


// 响应拦截器
instance.interceptors.response.use((res) => {


	if (res.config.url.indexOf('/item/updateShopItem') > -1
		|| res.config.url.indexOf('conversation/total/unread/count') > -1
		|| res.config.url.indexOf('chat/getUserMsg') > -1

	) {
		console.log('hide')
	} else {
		hideLoading();
	}
	if (res.data.code == 700) {
		localStorage.removeItem('userInfo')
		localStorage.removeItem('warehouse')
		localStorage.removeItem('shopIdInfo')
		localStorage.removeItem('secondPws')
		localStorage.removeItem('storeId')
		setTimeout(function () {
			location.replace('/loginPage')
		}, 3000)
	}

	if (res.config.url.indexOf('/query/queryOrders') > -1) {
		for (let i = 0; i < res.data.data.orders.length; i++) {
			if (!res.data.data.orders[i].address) {
				res.data.data.orders[i].address = {
					city: "",
					country: "",
					district: "",
					fullAddress: "",
					name: "",
					orderId: "",
					phone: "",
					state: "",
					town: "",
					zipCode: "",
				}
			}
		}
	}
	// console.log(9999)
	// console.log(res)
	// console.log(11111111)
	// console.log(res.data)
	// console.log(res.data.match(/[0-9]{19}/)[0])
	// console.log(333333333)
	return res;
}, (error) => {
	hideLoading()


	// if(error.response.status){
	// 	switch (error.response.status) {
	// 	    case 500:
	// 			Message({
	// 				message: '嗨，服务器打了一个小盹，请稍候重试！',
	// 				type: 'error'
	// 			});
	// 		break;  
	// 	}
	// }



	return Promise.reject(error) //请求错误时，直接结束
});




const fetch = options => {
	const { method = 'get', data, url } = options
	if (url.indexOf('access/image/upload/shopee') > -1 ||
		url == 'http://47.57.9.89:8120/conversation/mark/as/read' ||
		url == 'http://47.57.9.89:8120/message/insert' ||
		url == 'https://erp.shopsbu.com/sales/chat/purchase/order/balanceFinalPayment' ||
		url == 'http://47.57.9.89:8120/purchase/order/balanceFinalPayment' ||
		url == 'http://47.57.9.89:8120/purchase/order/audit' ||
		url == 'http://47.57.9.89:8120/product/library/audit' ||
		url == 'http://47.57.9.89:8120/product/library/audit' ||
		url == 'https://erp.shopsbu.com/sales/chat/product/library/audit' ||
		url == 'https://erp.shopsbu.com/sales/chat/purchase/order/comment/create' ||
		url == 'https://erp.shopsbu.com/sales/chat/purchase/order/update/status' ||
		url == 'https://erp.shopsbu.com/sales/chat/purchase/order/audit' ||
		url == 'https://erp.shopsbu.com/sales/chat/product/warehouse/delete' ||
		url == 'https://erp.shopsbu.com/sales/chat/purchase/order/remove' ||
		url == 'https://erp.shopsbu.com/sales/chat/product/supplier/delete' ||
		url == 'https://erp.shopsbu.com/sales/chat/conversation/delete/conversation' ||
		url == 'https://erp.shopsbu.com/sales/chat/conversation/mark/as/read' ||
		url == 'https://erp.shopsbu.com/sales/chat/message/insert' ||
		url == 'https://erp.shopsbu.com/sales/chat/conversation/create/conversation' ||
		url == 'https://erp.shopsbu.com/cus/set/automatic/reply/setting' ||
		url == 'https://erp.shopsbu.com/cus/collect/answer/behavior' ||
		url == 'https://erp.shopsbu.com/cus/update/shop/automatic/translate' ||
		url == 'https://erp.shopsbu.com/cus/user/auto/replay/update' ||
		url == 'https://erp.shopsbu.com/cus/message/sync/conversation' ||
		url == 'https://erp.shopsbu.com/crm/category/delete/consumer' ||
		url == 'https://erp.shopsbu.com/cus/category/insert/consumer' ||
		url == 'https://erp.shopsbu.com/crm/category/consumer/share' ||
		url == 'https://erp.shopsbu.com/crm/category/insert/consumer' ||
		url == 'https://erp.shopsbu.com/crm/update/category' ||
		url == 'https://erp.shopsbu.com/crm/delete/category' ||
		url == 'https://erp.shopsbu.com/crm/create/category' ||
		url == 'https://erp.shopsbu.com/cus/knowledge' && method.toLowerCase() == 'post' ||
		url == 'https://erp.shopsbu.com/cus/category/insert' ||
		url == 'https://erp.shopsbu.com/cus/message/cancel/order' ||
		url == 'https://erp.shopsbu.com/cus/message/add/ordernote' ||
		url == 'https://erp.shopsbu.com/crm/note/template/insert' ||
		url == 'https://erp.shopsbu.com/crm/openNoteChannel' ||
		url == 'https://erp.shopsbu.com/crm/note/template/test/send' ||
		url == 'https://erp.shopsbu.com/cus/message/textTranslate' ||
		url == 'https://erp.shopsbu.com/cus/message/insertMessage' ||
		url == 'https://erp.shopsbu.com/cus/message/update/pinned' ||
		url == 'https://erp.shopsbu.com/cus/message/read/conversation' ||
		url == 'https://erp.shopsbu.com/cus/message/delete/conversation' ||
		url == 'https://erp.shopsbu.com/cus/shortcut/insert/message' ||
		url == 'https://erp.shopsbu.com/cus/shortcut/insert/group' ||
		url == 'https://erp.shopsbu.com/crm/cod/switch') {

		return instance.post(
			`${url}${options.data ? `?${qs.stringify(options.data)}` : ''}`,
		)
	} else if (url == 'https://erp.shopsbu.com/cus/knowledge' && method == "put" || url == 'https://erp.shopsbu.com/crm/note/template' && method == "put" || url == 'https://erp.shopsbu.com/cus/shortcut/update/message' || url == 'https://erp.shopsbu.com/cus/shortcut/update/group') {
		return instance.put(
			`${url}${options.data ? `?${qs.stringify(options.data)}` : ''}`,
		)
	} else {

		switch (method.toLowerCase()) {
			case 'get':
				return instance.get(
					`${url}${options.data ? `?${qs.stringify(options.data)}` : ''}`,
				)
			case 'post':
				return instance.post(url, data)
			case 'put':
				return instance.put(url, qs.stringify(data))
			case 'delete':
				return instance.delete(
					`${url}${options.data ? `?${qs.stringify(options.data)}` : ''}`
				)
			default:
				return instance(options)
		}
	}
}
// http异步请求
export default async function http(options) {
	return fetch(options)
		.then(response => {
			return response
		})
		.catch(error => {
			return error
		})
}

